export const demoKo = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': '지금 플레이하기 — Grymwyrd에 들어서기',
  'demo.seoDescription':
    '세상을 돌려보고, 탁자에 자리를 잡으며, Grymwyrd 영웅을 창조하고, 주사위를 굴려라 — Grymwyrd 가상 탁자 게임의 안내 투어.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'Grymwyrd의 세상',
  'demo.globe.spinningWorld': '세상을 돌리는 중…',
  'demo.globe.tagline': '살아 숨 쉬는 공포-판타지 세계',
  'demo.globe.arrivedHeading': 'Greywick 지역',
  'demo.globe.heading': '영원한 황혼 속에서 자신의 자리를 찾으세요',
  'demo.globe.subheading': '세상의 심장에 탁자가 당신을 기다리고 있습니다. 자리를 잡고 영웅을 만들어보세요.',
  'demo.globe.enterCta': 'Grymwyrd로 내려가기',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': '이야기의 일부가 되세요',
  'demo.account.subheading':
    '무료 계정을 만들어 완전한 Grymwyrd 백과사전을 잠금 해제하고 만들려는 영웅을 저장하거나, 손님으로 지나가서 지금 바로 탐험해보세요.',
  'demo.account.createAccount': '계정 만들기',
  'demo.account.logIn': '로그인',
  'demo.account.continueAsGuest': '손님으로 계속하기',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability} (3d6)',
  'demo.create.initiativeLabel': '선제 공격권',
  'demo.create.lobbyEyebrow': 'Grymwyrd 가상 탁자 게임 · 로비',
  'demo.create.heading': '영웅을 창조하기',
  'demo.create.subheading': 'SRD 5.2.1 캐릭터, Grymwyrd에서 태어났습니다. 이름을 지어주고, 직업을 선택한 후 주사위를 굴려보세요.',
  'demo.create.nameLabel': '이름',
  'demo.create.namePlaceholder': '그들은 누가 될까요?',
  'demo.create.chooseCalling': '직업 선택하기',
  'demo.create.keyAbility': '핵심: {ability}',
  'demo.create.abilityScores': '능력치',
  'demo.create.abilityScoresHint': '— 클릭하여 3d6 굴리기',
  'demo.create.rollAbilityAria': '{ability} 굴리기 (3d6)',
  'demo.create.keepStandard': '또는 표준 10으로 유지하고 시작하세요.',
  'demo.create.initiativeResult': '선제 공격권 {initiative} — 주사위를 굴려라, 탁자가 당신을 향해 돌아가네요…',
  'demo.create.bonesTumble': '주사위가 굴러가는 중…',
  'demo.create.rollInitiativeCta': '선제 공격권 굴리기 & 자리 잡기',
  'demo.create.chooseCallingHint': '자리를 잡으려면 직업을 선택하세요.',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': '탁자를 준비할 수 없었습니다',
  'demo.table.errorBody': '지금은 가상 탁자 게임을 사용할 수 없습니다.',
  'demo.table.browseLiveTables': '대신 라이브 테이블 둘러보기',
  'demo.table.settingTable': '탁자를 준비하는 중…',
  'demo.table.connecting': '가상 탁자 게임에 연결하는 중…',
  'demo.table.heroTable': '{name}의 탁자',
  'demo.table.firstTable': '당신의 첫 탁자',
  'demo.table.diceTrayHeading': '주사위 트레이',
  'demo.table.initiativeHeading': '선제 공격권',
  'demo.table.initiativePrompt': '주사위를 굴려 전투 순서를 정하세요.',
  'demo.table.rollForInitiative': '선제 공격권 굴리기',
  'demo.table.vttEyebrow': 'Grymwyrd VTT',
  'demo.table.xcardTitle': '게임을 일시 정지하기, 익명으로',
  'demo.table.xcard': 'X-카드',
  'demo.table.saveHeroTitle': '영웅을 저장하려면 무료 계정을 만드세요',
  'demo.table.saveHero': '영웅 저장',
  'demo.table.statusLive': '라이브',
  'demo.table.statusConnecting': '연결 중',
  'demo.table.actionLogHeading': '행동 기록',
  'demo.table.recentRollsHeading': '최근 주사위 굴림',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': '영웅 시트',
  'demo.panel.companion': '동료 기기',
  'demo.panel.diceTray': '주사위 트레이',
  'demo.panel.macros': '매크로',
  'demo.panel.diceConsole': '주사위 콘솔',
  'demo.panel.initiative': '선제 공격권',
  'demo.panel.poll': '투표',
  'demo.panel.recentRolls': '최근 주사위 굴림',
  'demo.panel.reference': '참고자료',
  'demo.panel.chat': '채팅',
  'demo.panel.handouts': '핸드아웃',
  'demo.panel.safety': '안전 설정',
  'demo.panel.sceneAndCues': '장면 & 큐',
  'demo.panel.replay': '재생',
  'demo.panel.recap': '세션 요약',
  'demo.panel.actionLog': '행동 기록',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': '근접',
  'demo.action.cast': '마법 시전',
  'demo.action.move': '이동',
  'demo.action.block': '방어',
  'demo.action.chooseTarget': '{action}의 대상 선택…',
  'demo.action.controlling': '조종 중:',
  'demo.action.cannotAct': '{label}은(는) 행동할 수 없습니다 — 몹, 플레이어, 탈것, 또는 NPC를 선택하세요.',
  'demo.action.selectActionable': '함께 행동할 수 있는 객체를 선택하세요.',
  'demo.action.cancel': '취소',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': '순서를 정하는 중…',
  'demo.tracker.combatant': '전투자 {n}',
  'demo.tracker.previousTurn': '이전 차례',
  'demo.tracker.round': '라운드 {round}',
  'demo.tracker.endCombatTitle': '전투 종료',
  'demo.tracker.end': '종료',
  'demo.tracker.nextTurnTitle': '다음 차례',
  'demo.tracker.next': '다음',
  'demo.tracker.hitPoints': '체력',
  'demo.tracker.reduceHp': '{name}의 체력 감소',
  'demo.tracker.raiseHp': '{name}의 체력 증가',
  'demo.tracker.addStatusEffect': '상태 효과 추가',
  'demo.tracker.removeFromOrder': '순서에서 제거',
  'demo.tracker.removeFromOrderTitle': '순서에서 제거',
  'demo.tracker.removeCondition': '{name} 제거',
  'demo.tracker.roundsShort': '{n}R',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': '탁자가 일시 정지됨',
  'demo.xcard.heading': '탁자가 일시 정지됨',
  'demo.xcard.body':
    '누군가가 X-카드를 들었습니다. 질문 없이, 이름도 없이 멈춥니다. 모두 준비되면 계속하세요.',
  'demo.xcard.resume': '준비됐습니다 — 계속하기',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': '핸드아웃',
  'demo.handouts.titlePlaceholder': '제목 (선택)',
  'demo.handouts.bodyPlaceholder': '메모, 단서, 읽어주는 텍스트…',
  'demo.handouts.push': '테이블에 보내기',
  'demo.handouts.whispered': '속삭임',
  'demo.handouts.dismiss': '핸드아웃 닫기',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': '안전 설정',
  'demo.safety.description': '건너뛸 선; 덮을 베일. 탁자 모두가 공유하지만, 누구에게도 돌리지 않습니다.',
  'demo.safety.linesLabel': '라인 (절대 금지)',
  'demo.safety.veilsLabel': '베일 (암전)',
  'demo.safety.removeItem': '"{item}" 제거',
  'demo.safety.addLinePlaceholder': '라인 추가…',
  'demo.safety.addVeilPlaceholder': '베일 추가…',
  'demo.safety.addLine': '라인 추가',
  'demo.safety.addVeil': '베일 추가',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': '영웅 시트',
  'demo.sheet.hp': 'HP',
  'demo.sheet.ac': 'AC',
  'demo.sheet.classLevel': '{className} · Lv 1',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': '동료 기기',
  'demo.companion.description':
    '휴대폰 또는 태블릿을 읽기 전용 보조 화면으로 페어링하세요 — 선제 공격권, 최근 주사위 굴림, 장면이 기기에 미러링됩니다. 언제든 취소할 수 있습니다.',
  'demo.companion.pairDevice': '기기 페어링',
  'demo.companion.qrAriaLabel': '동료 기기 페어링 QR 코드',
  'demo.companion.copied': '복사됨',
  'demo.companion.copyLink': '링크 복사',
  'demo.companion.revoke': '취소',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': '주사위 매크로',
  'demo.macros.dismissError': '오류 닫기',
  'demo.macros.newMacro': '새 매크로',
  'demo.macros.namePlaceholder': '이름 (점 없음)',
  'demo.macros.labelPlaceholder': '버튼 라벨 (선택)',
  'demo.macros.save': '매크로 저장',
  'demo.macros.noDots': '매크로 이름은 점을 포함할 수 없습니다.',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': '투표',
  'demo.poll.questionPlaceholder': '테이블에 질문…',
  'demo.poll.optionPlaceholder': '선택 {n}',
  'demo.poll.removeOption': '선택 {n} 제거',
  'demo.poll.addOption': '선택 추가',
  'demo.poll.openPoll': '투표 시작',
  'demo.poll.live': '라이브',
  'demo.poll.closed': '투표 종료됨',
  'demo.poll.vote': '투표',
  'demo.poll.closePoll': '투표 종료',
  'demo.poll.startNewPoll': '새 투표 시작',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': '세션 요약',
  'demo.recap.tagline': '당신의 테이블 이야기, 먼지가 가라앉을 때.',
  'demo.recap.gathering': '이야기를 모으는 중…',
  'demo.recap.getRecap': '세션 요약 받기',
  'demo.recap.notableRolls': '주목할 만한 주사위 굴림',
  'demo.recap.copied': '복사됨!',
  'demo.recap.share': '공유',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': '참고자료',
  'demo.reference.searchPlaceholder': '몬스터, 마법, 규칙 검색…',
  'demo.reference.searchAria': '공유할 백과사전 검색',
  'demo.reference.typeToSearch': '살아 있는 백과사전을 검색하려면 최소 두 글자를 입력하세요.',
  'demo.reference.searching': '검색 중…',
  'demo.reference.open': '{title} 열기',
  'demo.reference.share': '공유',
  'demo.reference.dismiss': '참고자료 닫기',
  'demo.reference.backToSearch': '검색으로 돌아가기',
  'demo.reference.loadingContent': '콘텐츠를 불러오는 중…',
  'demo.reference.notOwned':
    '아직 이 책을 소유하지 않았습니다. 라이브러리에 추가하면 전체 참고자료가 잠금 해제됩니다.',
  'demo.reference.contentDown': '지금은 콘텐츠를 사용할 수 없습니다. 잠시 후 다시 시도하세요.',
  'demo.reference.noAdditionalContent': '이 참고자료에 추가 콘텐츠가 없습니다.',
  'demo.reference.noLinkedContent': '이 참고자료에 연결된 책 콘텐츠가 없습니다.',
  'demo.reference.shareToTable': '테이블에 공유',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': '재생',
  'demo.replay.tagline': '세션을 장면별로 다시 걸어보세요.',
  'demo.replay.loading': '불러오는 중…',
  'demo.replay.loadReplay': '재생 불러오기',
  'demo.replay.loadMore': '더 불러오기',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': '주사위',
  'demo.dice.dismissError': '오류 닫기',
  'demo.dice.labelPlaceholder': '공격 (선택)',
  'demo.dice.roll': '굴리기',
  'demo.dice.rolledForReal': '실제로 굴렸습니다',
  'demo.dice.totalPlaceholder': '합계 (필수)',
  'demo.dice.physNotationPlaceholder': '1d20+5 (선택)',
  'demo.dice.physLabelPlaceholder': '라벨 (선택)',
  'demo.dice.logPhysical': '물리 주사위 굴림 기록',
  'demo.dice.onTable': '🎲 테이블 위',
  'demo.dice.private': '비공개',
  'demo.dice.public': '공개',
  'demo.dice.rolledPrivately': '비공개로 굴림',
  'demo.dice.exploded': '폭발',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': '장면 & 큐',
  'demo.scene.current': '장면: {scene}',
  'demo.scene.cueSuffix': '— 큐: {cue}',
  'demo.scene.noScene': '장면 없음',
  'demo.scene.oneShotCues': '원샷 큐',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} at {x},{y}',
  'demo.map.tile': '타일 {x},{y}',
  'demo.map.fogged': '안개',
  'demo.map.battleMap': '전투 맵',
  'demo.map.gm': 'GM',
  'demo.map.noMap': '맵 없음',
  'demo.map.uploadedMap': '업로드된 맵',
  'demo.map.uploadTitle': '맵 이미지를 캔버스 배경으로 업로드',
  'demo.map.reading': '읽는 중…',
  'demo.map.upload': '업로드',
  'demo.map.size': '크기',
  'demo.map.shrinkMap': '맵 축소',
  'demo.map.growMap': '맵 확대',
  'demo.map.widthShort': '너',
  'demo.map.narrowMap': '맵 좁히기',
  'demo.map.widenMap': '맵 넓히기',
  'demo.map.heightShort': '높',
  'demo.map.shortenMap': '맵 단축',
  'demo.map.heightenMap': '맵 늘리기',
  'demo.map.fitTitle': '위치 초기화 + 그리드에 맞게 확대',
  'demo.map.fit': '맞추기',
  'demo.map.lock': '잠금',
  'demo.map.adjust': '조정',
  'demo.map.fogOn': '안개 ON — 클릭하여 비활성화',
  'demo.map.fogOff': '안개 OFF — 클릭하여 활성화',
  'demo.map.fog': '안개',
  'demo.map.exitPaintTitle': '페인트 모드 종료',
  'demo.map.paintTitle': '안개 페인트 — 셀을 클릭하거나 드래그하여 공개/숨김',
  'demo.map.exitPaint': '페인트 종료',
  'demo.map.paint': '페인트',
  'demo.map.hexGridTitle': '육각형 격자 — 클릭하여 정사각형으로',
  'demo.map.squareGridTitle': '정사각형 격자 — 클릭하여 육각형으로',
  'demo.map.hex': '육각형',
  'demo.map.zoomOut': '축소',
  'demo.map.zoomLevel': '줌 레벨',
  'demo.map.zoomIn': '확대',
  'demo.map.resetView': '보기 초기화',
  'demo.map.reset': '초기화',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': '{title} 확장',
  'demo.dock.collapse': '{title} 축소',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': '탁자를 떠나시겠습니까?',
  'demo.leave.heading': '탁자를 떠나시겠습니까?',
  'demo.leave.body':
    '게임 진행 중입니다. 이것은 손님 테이블입니다 — 지금 떠나면 세션이 끝나고 당신의 영웅은 사라집니다.',
  'demo.leave.stay': '탁자에 머물기',
  'demo.leave.leaveAnyway': '어쨌든 떠나기',
}
